<template>
  <div>
    <!-- E45 · Nada marcado al abrir: regenerar reemplaza trabajo hecho, así que elegir qué
         se toca es la decisión del usuario y no un valor por defecto que hay que desarmar. -->
    <b-form-group
      :label="$t('reusable.aiInstructionalBuilderModal.redoPartsTitle')"
      class="mb-2"
    >
      <b-form-checkbox-group :checked="parts" stacked @input="emitParts">
        <b-form-checkbox :value="REDO_PART_NAME" :disabled="disabled">
          {{ $t("reusable.aiInstructionalBuilderModal.redoPartName") }}
        </b-form-checkbox>
        <b-form-checkbox :value="REDO_PART_TEXTS" :disabled="disabled">
          {{ $t("reusable.aiInstructionalBuilderModal.redoPartTexts") }}
        </b-form-checkbox>
        <!-- El Tipo de Trabajo se nombra con la clave del Programa y no con el texto
             suelto: es el mismo campo del formulario de la evaluación, y si allá se
             renombra, acá tiene que decir lo mismo. -->
        <b-form-checkbox :value="REDO_PART_CATALOGS" :disabled="disabled">
          {{
            $t("reusable.aiInstructionalBuilderModal.redoPartCatalogs", {
              work_type: $t("matterProgram.matterProgramView.workType"),
            })
          }}
        </b-form-checkbox>
      </b-form-checkbox-group>
    </b-form-group>

    <!-- Debajo de las casillas: primero se elige qué rehacer y después, si hace falta, se
         orienta el enfoque. -->
    <b-form-group
      :label="`${$t('reusable.aiInstructionalBuilderModal.themeTitle')} (${$t(
        'reusable.aiInstructionalBuilderModal.optional'
      )})`"
      :description="
        $t('reusable.aiInstructionalBuilderModal.redoThemeHint', {
          entity: entity_name,
        })
      "
      class="mb-2"
    >
      <b-form-input
        :value="theme"
        size="sm"
        :placeholder="
          $t('reusable.aiInstructionalBuilderModal.themePlaceholder')
        "
        :disabled="disabled"
        @input="$emit('update:theme', $event)"
        @keyup.enter="$emit('submit')"
      ></b-form-input>
    </b-form-group>

    <b-alert show variant="info" class="kl-redo-keeps">
      {{ $t("reusable.aiInstructionalBuilderModal.redoKeeps") }}
    </b-alert>
  </div>
</template>

<script>
/**
 * E45 · Las opciones de "regenerar esta pieza con IA".
 *
 * Vive acá y no en cada punto porque hay dos entradas a la misma acción —el botón de cada
 * tarjeta del diseño y la lista de piezas que ya existen del paso 1 del builder— y lo que
 * no puede pasar es que las dos ofrezcan cosas distintas: quien aprende en una y usa la
 * otra perdería texto sin haberlo decidido. La lógica correspondiente está compartida en
 * `redoPieceWithAi`; esto es su cara visible.
 *
 * No decide nada ni llama al backend: sólo recoge qué partes y con qué tema, y avisa.
 */
import {
  REDO_PART_CATALOGS,
  REDO_PART_NAME,
  REDO_PART_TEXTS,
} from "@/components/teaching/Instructional/createDesignEvaluation";

export default {
  name: "RedoPieceFields",
  props: {
    // Las partes marcadas. Se usa con `:parts.sync`.
    parts: {
      type: Array,
      default: () => [],
    },
    // El tema u orientación opcional. Se usa con `:theme.sync`.
    theme: {
      type: String,
      default: "",
    },
    // Cómo se llama la pieza —"Actividad", "Diagnóstica"—, para el texto del tema.
    entity_name: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      REDO_PART_NAME: REDO_PART_NAME,
      REDO_PART_TEXTS: REDO_PART_TEXTS,
      REDO_PART_CATALOGS: REDO_PART_CATALOGS,
    };
  },
  methods: {
    emitParts(value) {
      this.$emit("update:parts", value);
    },
  },
};
</script>

<style scoped>
.kl-redo-keeps {
  font-size: var(--kl-fs-small);
  margin-bottom: 0.75rem;
}
</style>
